"use strict";

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleTwoFactor = exports.handlePromise = exports.handleErrors = exports.CONTENT_TYPE_MULTIPART_FORM = exports.CONTENT_TYPE_JSON = void 0;

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

var _includes2 = _interopRequireDefault(require("lodash/includes"));

var _types = require("./types");

var _statusCodes = _interopRequireDefault(require("./statusCodes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var CONTENT_TYPE_JSON = 'application/json';
exports.CONTENT_TYPE_JSON = CONTENT_TYPE_JSON;
var CONTENT_TYPE_MULTIPART_FORM = 'multipart/form-data';
exports.CONTENT_TYPE_MULTIPART_FORM = CONTENT_TYPE_MULTIPART_FORM;

var handleErrors = function handleErrors(_ref) {
  var _ref2 = _slicedToArray(_ref, 4),
      ok = _ref2[0],
      response = _ref2[1],
      status = _ref2[2],
      statusText = _ref2[3];

  if (!ok) {
    var errorMessage = (0, _types.isResponseType)(response) && (response.error && response.error.message || response.errorMessage) || 'An error has occurred';
    var error = new Error(errorMessage);
    error.response = response;
    error.status = status;
    error.statusText = statusText;
    throw error;
  }

  return response;
};

exports.handleErrors = handleErrors;

var handlePromise = function handlePromise(response) {
  var contentType = response.headers && response.headers.get('Content-Type');

  if ((0, _includes2.default)(contentType, CONTENT_TYPE_JSON)) {
    return Promise.all([response.ok, response.json(), response.status, response.statusText]);
  }

  return Promise.all([response.ok, response.text(), response.status, response.statusText]);
}; // Requires web-nav on the page for proper handling
// Will fallback to an error if it does not exist


exports.handlePromise = handlePromise;

var handleTwoFactor = function handleTwoFactor(e, callback) {
  if (e.status === _statusCodes.default.TWO_FACTOR && (typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && window.zolaNav) {
    var twoFactorResponse = e.response;
    window.zolaNav.openTwoFAModal({
      verificationCopy: twoFactorResponse.verification_copy,
      notifiedValue: twoFactorResponse.notified_value,
      verifiedCallback: callback
    });
  } else {
    throw e;
  }
};

exports.handleTwoFactor = handleTwoFactor;